import React from 'react';
import styles from './QuizMessage.module.scss';
import classNames from 'classnames';
import { TypingEffect } from '../../ui';
import FlexiiLogo from '../../../assets/icons/miniLogo.svg';
import DownloadIcon from '../../../assets/icons/download.svg';
import EditIcon from '../../../assets/icons/edit.svg';

interface QuizMessageProps {
  type: 'question' | 'answer';
  content: string;
  showTyping?: boolean;
  fileName?: string;
  isFile?: boolean;
  fileUrl?: string;
  onEdit?: () => void;
  showEdit?: boolean;
}

const QuizMessage: React.FC<QuizMessageProps> = ({
  type,
  content,
  showTyping = false,
  fileName,
  isFile = false,
  fileUrl,
  onEdit,
  showEdit = false,
}) => {
  const handleDownload = () => {
    if (fileUrl && fileUrl !== '-') {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName || 'file');
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
        })
        .catch((err) => console.error('Download error:', err));
    }
  };

  if (type === 'question') {
    return (
      <li className={styles.questionMessage}>
        <img src={FlexiiLogo} alt="FLEXX-i" className={styles.logo} />
        <p>{showTyping ? <TypingEffect text={content} speed={30} /> : content}</p>
      </li>
    );
  }

  return (
    <li
      className={classNames(styles.answerMessage, {
        [styles.fileAnswer]: isFile,
      })}
    >
      <p>
        {isFile ? fileName : content}

        {isFile && fileUrl && fileUrl !== '-' && (
          <img
            src={DownloadIcon}
            alt="Download"
            onClick={handleDownload}
            className={styles.actionIcon}
          />
        )}

        {showEdit && onEdit && (
          <img src={EditIcon} alt="Edit" onClick={onEdit} className={styles.actionIcon} />
        )}
      </p>
    </li>
  );
};

export default QuizMessage;
